"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components")); /// todo refactor!


exports.RowWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      wrap = _a.wrap,
      justify = _a.justify,
      align = _a.align,
      flexwrap = _a.flexwrap,
      width = _a.width,
      rest = __rest(_a, ["activeBreakpoint", "wrap", "justify", "align", "flexwrap", "width"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    ", "\n"], ["\n    display: flex;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      align = _a.align,
      wrap = _a.wrap,
      justify = _a.justify,
      flexwrap = _a.flexwrap;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            flex-flow: row " + (wrap ? 'wrap' : 'nowrap') + ";\n            justify-content: " + (justify || 'center') + ";\n            align-items: " + (align || 'center') + ";\n            " + (flexwrap ? "flex-wrap: " + flexwrap + ";" : '') + "\n            " + (small ? 'width: 100%;' : '') + "    \n        ";
});
exports.default = responsive_1.withResponsiveMeta(exports.RowWrapper);
var templateObject_1;